// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'materialSymbols', 'materialSymbols Fallback'","fontStyle":"normal"},"className":"__className_59deff","variable":"__variable_59deff"};